import React from 'react';

import './InteractiveDiv.module.css';

const InteractiveDiv = ({
  className,
  children,
  handler,
  handleTab,
  ...props
}) => (
  <button
    styleName="div"
    className={className}
    onClick={handler}
    onFocus={handleTab && handler}
    {...props}
  >
    {children}
  </button>
);

export default InteractiveDiv;
